import { useState, useLayoutEffect } from "react";


const DOMAINS = [
  "All Expertise",
  "Consulting & Strategy",
  "Legal & Compliance",
  "Finance & Taxation",
  "Funding & Investor Relations",
  "Digital Marketing & Promotions",
  "Technology & Product",
  "Operations & Supply Chain",
  "HR & Talent Acquisition",
  "PR & Media Relations",
  "International Trade & Import-Export",
  "MSME & Govt Liaison",
  "Startup & Innovation Cell",
  "Content Management",
  "Zumba & Fitness",
  "Mind Motivation & Life Coaching",
  "Real Estate & Infrastructure",
  "Manufacturing & Industrial Advisory",
  "Branding & Marketing Strategy",
  "Women Entrepreneurship Cell",
  "NRI / Global Bengali Desk",
  "Digital Branding & Marketing"
];

const founders = [
  { id: 201,
    name: "Sudipto Kumar Ghosh",  
    role: "Founder",     
    designation: "Operations & Execution Head",              
    photo: "/images/founders/SUDIPTO KUMAR GHOSH.avif",  
    initials: "SG", 
    avatarColor: { bg: "#fff3e0", text: "#c2410c" }
 },
  
  { id: 203, 
    name: "Anirban Chakraborty",  
    role: "Co-Founder",  
    designation: "Brand Growth & Strategic Head",             
    photo: "/images/founders/ANIRBAN CHAKRABORTY.avif",   
    initials: "AC", 
    avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
  
];

const experts = [
  { id: 1, 
    name: "Anindita Sharma",     
    designation: "HR & Talent Acquisition",                  
    photo: "/images/experts/ANINDITA SHARMA.avif",      
    initials: "AS", 
    domain: "HR & Talent Acquisition",              
    avatarColor: { bg: "#fce7f3", text: "#be185d" } 
  },
  { id: 2, 
    name: "Ranit Biswas",        
    designation: "Legal & Compliance | Finance & Taxation",   
    photo: "/images/experts/RANIT BISWAS.avif",          
    initials: "RB", 
    domain: "Legal & Compliance",                   
    avatarColor: { bg: "#dbeafe", text: "#1d4ed8" } 
  },
  { id: 3, 
    name: "Saraj Dey",           
    designation: "Zumba & Fitness",                           
    photo: "/images/experts/SARAJ DEY.avif",             
    initials: "SD", 
    domain: "Zumba & Fitness",                      
    avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
  { id: 4, 
    name: "Supriyo Chatterjee",  
    designation: "Digital Marketing | Content Management",    
    photo: "/images/experts/SUPRIYO CHATTERJEE.avif",    
    initials: "SC", 
    domain: "Digital Marketing & Promotions",        
    avatarColor: { bg: "#ffedd5", text: "#c2410c" } 
  },
  { id: 5, 
    name: "Nikhil Jhawar",       
    designation: "Legal & Compliance",                        
    photo: "/images/experts/NIKHIL JHAWAR.avif",         
    initials: "NJ", 
    domain: "Legal & Compliance",                   
    avatarColor: { bg: "#ede9fe", text: "#6d28d9" } 
  },
  { id: 6, 
    name: "Subhayu Kumar Ghosh", 
    designation: "Digital Branding & Marketing",       
    photo: "/images/experts/Subhayu.avif",   
    initials: "SG", 
    domain: "Manufacturing & Industrial Advisory",   
    avatarColor: { bg: "#ccfbf1", text: "#0f766e" } 
  },
  { id: 7, 
    name: "Sayon Mondal",        
    designation: "Startup & Innovation Cell",                 
    photo: "/images/experts/SAYON MONDAL.avif",          
    initials: "SM", domain: "Startup & Innovation Cell",             
    avatarColor: { bg: "#e0e7ff", text: "#3730a3" } 
  },
  { id: 8, 
    name: "Srabanee Chakraborty",
    designation: "PR & Media Relations",                      
    photo: "/images/experts/SRABANEE CHAKRABORTY.avif",  
    initials: "SC", 
    domain: "PR & Media Relations",                  
    avatarColor: { bg: "#fce7f3", text: "#be185d" } 
  },
  { id: 9, 
    name: "Pushpam",             
    designation: "International Trade & Import Export",       
    photo: "/images/experts/PUSHPAM.avif",               
    initials: "P",  
    domain: "International Trade & Import Export",   
    avatarColor: { bg: "#fce7f3", text: "#be185d" } 
  },
  { id: 10, 
    name: "Sukanya Debnath",    
    designation: "Mind Motivation & Life Coaching",           
    photo: "/images/experts/Sukanya Debnath.avif",       
    initials: "SD", 
    domain: "Mind Motivation & Life Coaching",       
    avatarColor: { bg: "#fce7f3", text: "#be185d" } 
  },
];

const seniorAdvisory = [
  { id: 101, 
    name: "Debashis Sen",    
    designation: "IAS retd. (Ex-Managing Director, WBHIDCO, Ex-Additional Chief Secretary IT, West Bengal)", 
    photo: "/images/advisors/DEBASHIS SEN.avif",     
    initials: "DS", avatarColor: { bg: "#ede9fe", text: "#6d28d9" } 
  },
  { id: 102, 
    name: "Smarajit Mitra",  
    designation: "Chairman - Merchants' Chamber of Commerce & Industry (MCCI)",         
    photo: "/images/advisors/SMARAJIT MITRA.avif",  
    initials: "SM", avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
  { id: 103, 
    name: "Sammi Reddy Marepally",  
    designation: "IIT, Kharagpur (Ex-Hindustan Aeronautics Limited)",         
    photo: "/images/advisors/Sammi Reddy Marepally.avif",  
    initials: "SM", avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
  { id: 104, 
    name: "Somnath Ghosh",  
    designation: "Career & Education Facilitator",         
    photo: "/images/advisors/Somnath Ghosh.avif",  
    initials: "SG", avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
   { id: 105, 
    name: "Pitam Chatterjee",  
    designation: "Founder, MyTwoCents ADVISORY",         
    photo: "/images/advisors/Pitam Chatterjee.avif",  
    initials: "PC", avatarColor: { bg: "#dcfce7", text: "#166534" } 
  },
];
const SECTION_COLORS = {
  founders:       { accent: "#f37c23", bgLight: "rgba(243,124,35,0.08)",  border: "rgba(243,124,35,0.35)" },
  experts:        { accent: "#002a9b", bgLight: "rgba(0,42,155,0.07)",    border: "rgba(0,42,155,0.30)"  },
  seniorAdvisory: { accent: "#00a000", bgLight: "rgba(0,160,0,0.07)",     border: "rgba(0,160,0,0.30)"   },
};

const IconUsers      = ({ size=20, color="currentColor" }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>;
const IconSearch     = ({ size=14, color="#aaa" })         => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>;
const IconChevronDown= ({ size=12, color="#777" })         => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>;
const IconArrowRight = ({ size=14, color="currentColor" }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>;
const IconPhone      = ({ size=16, color="currentColor" }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>;

function Avatar({ person, size = 64 }) {
  const [err, setErr] = useState(false);
  const style = {
    width: size, height: size, borderRadius: "50%", flexShrink: 0, overflow: "hidden",
    display: "flex", alignItems: "center", justifyContent: "center",
    background: person.avatarColor?.bg || "#e8e8f8",
    fontSize: size * 0.28, fontWeight: 700,
    color: person.avatarColor?.text || "#444",
    fontFamily: "'Poppins', sans-serif",
    border: "2.5px solid rgba(255,255,255,0.9)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
  };
  if (person.photo && !err) return (
    <div style={style}>
      <img src={person.photo} alt={person.name} onError={() => setErr(true)}
        style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center" }} />
    </div>
  );
  return <div style={style}>{person.initials}</div>;
}

function Tag({ label, color }) {
  return (
    <span style={{ fontSize: 10, padding: "2px 9px", borderRadius: 20,
      background: color + "15", color, fontFamily: "'Inter', sans-serif",
      fontWeight: 600, border: `1px solid ${color}30` }}>
      {label}
    </span>
  );
}

function PersonCard({ person, accentColor }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex", alignItems: "center", gap: 16,
        border: `1px solid ${hovered ? accentColor + "55" : "#e8e8f0"}`,
        borderRadius: 14, padding: "18px 16px",
        background: hovered ? accentColor + "04" : "#fff",
        transition: "border-color 0.2s, box-shadow 0.2s, background 0.2s",
        boxShadow: hovered ? `0 4px 20px ${accentColor}18` : "none",
        cursor: "default",
      }}>
      <Avatar person={person} size={100} />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 700, color: "#0f0c2e", fontFamily: "'Poppins', sans-serif", marginBottom: 2 }}>
          {person.name}
        </div>
        {person.role && (
          <div style={{ fontSize: 11.5, fontWeight: 600, color: accentColor, fontFamily: "'Inter', sans-serif", marginBottom: 2 }}>
            {person.role}
          </div>
        )}
        <div style={{ fontSize: 11, color: "#888", fontFamily: "'Inter', sans-serif", lineHeight: 1.4 }}>
          {person.designation}
        </div>
        {person.tags && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 8 }}>
            {person.tags.map(t => <Tag key={t} label={t} color={accentColor} />)}
          </div>
        )}
      </div>
    </div>
  );
}

function ExpertCard({ person }) {
  const [hovered, setHovered] = useState(false);
  const accent = "#002a9b";
  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center",
        gap: 7, padding: "18px 10px 16px", borderRadius: 12,
        border: `1px solid ${hovered ? accent + "40" : "#eee"}`,
        background: hovered ? accent + "04" : "#fff",
        transition: "border-color 0.2s, box-shadow 0.2s, background 0.2s",
        boxShadow: hovered ? `0 4px 16px ${accent}14` : "none",
        position: "relative",
      }}>
      <Avatar person={person} size={100} />
      <div style={{ fontSize: 13, fontWeight: 700, color: "#0f0c2e", fontFamily: "'Poppins', sans-serif", lineHeight: 1.3 }}>
        {person.name}
      </div>
      <div style={{ fontSize: 10.5, color: "#777", fontFamily: "'Inter', sans-serif", lineHeight: 1.3, maxWidth: 110 }}>
        {person.designation}
      </div>
    </div>
  );
}

function SectionCard({ icon, title, subtitle, accent, border, children }) {
  return (
    <div style={{
      background: "#fff", borderRadius: 18, padding: "26px 24px 22px", marginBottom: 18,
      border: border || "1px solid #e8e8f0",
      boxShadow: "0 2px 16px rgba(0,0,0,0.04)",
    }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 22, gap: 12 }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0,
          background: accent + "18", display: "flex", alignItems: "center", justifyContent: "center", color: accent }}>
          {icon}
        </div>
        <div>
          <div style={{ fontSize: 17, fontWeight: 700, color: accent, fontFamily: "'Poppins', sans-serif" }}>{title}</div>
          <div style={{ fontSize: 12, color: "#999", fontFamily: "'Inter', sans-serif", marginTop: 1 }}>{subtitle}</div>
        </div>
      </div>
      {children}
    </div>
  );
}

const particles = [
  { top: "18%", left: "12%",  size: 3,   opacity: 0.55, delay: "0s",    dur: "6s"  },
  { top: "70%", left: "8%",   size: 2,   opacity: 0.40, delay: "1.2s",  dur: "8s"  },
  { top: "40%", left: "30%",  size: 2.5, opacity: 0.35, delay: "2.5s",  dur: "7s"  },
  { top: "82%", left: "45%",  size: 2,   opacity: 0.30, delay: "0.8s",  dur: "9s"  },
  { top: "25%", left: "60%",  size: 3,   opacity: 0.45, delay: "3.1s",  dur: "5.5s"},
  { top: "55%", left: "72%",  size: 2,   opacity: 0.35, delay: "1.7s",  dur: "7.5s"},
  { top: "12%", left: "82%",  size: 2.5, opacity: 0.50, delay: "0.4s",  dur: "6.5s"},
  { top: "75%", left: "88%",  size: 2,   opacity: 0.30, delay: "2.2s",  dur: "8.5s"},
];

const HERO_LANDSCAPE_SRC = "/images/hero/2 murti.avif";

function HeroLandscapeImage() {
  const [err, setErr] = useState(false);

  if (err) {
    return (
      <div style={{
        position: "absolute", inset: 0, display: "flex",
        alignItems: "center", justifyContent: "center",
        opacity: 0.08, pointerEvents: "none",
      }}>
        <svg width="220" height="220" viewBox="0 0 220 220" fill="none">
          <circle cx="110" cy="110" r="108" stroke="white" strokeWidth="1.5" strokeDasharray="6 4"/>
          <circle cx="110" cy="80"  r="30"  stroke="white" strokeWidth="1.5"/>
          <path   d="M50 180 Q110 130 170 180" stroke="white" strokeWidth="1.5" fill="none"/>
        </svg>
      </div>
    );
  }

  return (
    <>
      <img
        className="ibh-hero-img"
        src={HERO_LANDSCAPE_SRC}
        alt="IBH team"
        onError={() => setErr(true)}
        style={{
          position: "absolute",
          bottom: 0,
          right: "2%",
          height: "130%",
          width: "auto",
          pointerEvents: "none",
        }}
      />
    </>
  );
}

export default function TeamPage() {
  const [search, setSearch] = useState("");
  const [domain, setDomain] = useState("All Expertise");

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const filteredExperts = experts.filter(e => {
    const matchSearch = !search.trim() ||
      [e.name, e.designation].join(" ").toLowerCase().includes(search.toLowerCase());
    const matchDomain = domain === "All Expertise" ||
      e.domain === domain ||
      e.designation.toLowerCase().includes(domain.toLowerCase());
    return matchSearch && matchDomain;
  });

  const fc = SECTION_COLORS.founders;
  const ec = SECTION_COLORS.experts;
  const ac = SECTION_COLORS.seniorAdvisory;

  return (
    <>
      <style>{`
        
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', sans-serif; }

        @keyframes ibh-float {
          0%   { transform: translateY(0px) scale(1);   opacity: var(--op); }
          50%  { transform: translateY(-14px) scale(1.3); opacity: calc(var(--op) * 0.5); }
          100% { transform: translateY(0px) scale(1);   opacity: var(--op); }
        }
        .ibh-particle {
          position: absolute; border-radius: 50%; background: #fff;
          animation: ibh-float var(--dur) ease-in-out var(--delay) infinite;
          pointer-events: none; filter: blur(0.5px);
          box-shadow: 0 0 6px 2px rgba(167,139,250,0.6);
        }
        .ibh-search:focus {
          outline: none;
          border-color: #002a9b !important;
          box-shadow: 0 0 0 3px rgba(0,42,155,0.12) !important;
        }
        .ibh-select:focus { outline: none; }

        .experts-grid  { display: grid; grid-template-columns: repeat(5, 1fr); gap: 12px; }
        .founders-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px; }
        .advisory-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; }

        .cta-btn {
          background: #6c3cf7; color: #fff; border: none; border-radius: 9px;
          padding: 13px 24px; font-size: 13px; font-weight: 700; cursor: pointer;
          white-space: nowrap; display: inline-flex; align-items: center; gap: 8px;
          font-family: 'Inter', sans-serif; text-decoration: none;
          transition: background 0.2s, transform 0.1s;
        }
        .cta-btn:hover  { background: #5a2de0; transform: translateY(-1px); }
        .cta-btn:active { transform: translateY(0); }

        .back-btn {
          background: none; border: none; color: rgba(255,255,255,0.75);
          font-size: 10px; font-weight: 700; font-family: 'Inter', sans-serif;
          letter-spacing: 0.12em; text-transform: uppercase; cursor: pointer; padding: 0;
        }

        /* ── Large tablet / small laptop (≤1100px): iPad Pro 1024px ── */
        @media (max-width: 1100px) {
          .founders-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .experts-grid  { grid-template-columns: repeat(4, 1fr) !important; }
          .ibh-hero-img  { display: block !important; height: 105% !important; right: 2% !important; }
          .ibh-hero-text { max-width: min(420px, 44%) !important; }
        }

        /* ── Nest Hub landscape (1024×600) — short viewport ── */
        @media (max-width: 1100px) and (max-height: 650px) {
          .ibh-hero      { min-height: unset !important; padding: 32px 44px !important; }
          .ibh-hero-img  { height: 100% !important; right: 1% !important; }
          .ibh-hero-text { max-width: min(380px, 42%) !important; }
        }

        /* ── Surface Pro 7 (912px) / Asus Zenbook (853px) ── */
        @media (max-width: 960px) {
          .experts-grid  { grid-template-columns: repeat(3, 1fr) !important; }
          .advisory-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .ibh-hero-img  { display: block !important; height: 100% !important; right: 0 !important; }
          .ibh-hero-text { max-width: min(380px, 42%) !important; }
        }

        /* ── iPad Air (820px) ── */
        @media (max-width: 860px) {
          .ibh-hero      { min-height: 240px !important; padding: 36px 28px !important; }
          .ibh-hero-img  { display: block !important; height: 90% !important; right: -8px !important; }
          .ibh-hero-text { max-width: min(340px, 44%) !important; }
          .experts-grid  { grid-template-columns: repeat(3, 1fr) !important; }
        }

        /* ── iPad Mini (768px) ── */
        @media (max-width: 780px) {
          .ibh-hero      { min-height: 220px !important; padding: 32px 24px !important; }
          .ibh-hero-img  { display: block !important; height: 84% !important; right: -4px !important; }
          .ibh-hero-text { max-width: min(300px, 44%) !important; }
          .founders-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .experts-grid  { grid-template-columns: repeat(3, 1fr) !important; }
        }

        /* ── Large phone landscape / small tablet (≤667px) ── */
        @media (max-width: 667px) {
          .ibh-hero-img  { display: none !important; }
          .ibh-hero-text { max-width: 100% !important; }
          .ibh-hero      { padding: 36px 20px 40px !important; min-height: unset !important; }
          .ibh-content   { padding: 16px 14px 60px !important; }
          .founders-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .experts-grid  { grid-template-columns: repeat(2, 1fr) !important; }
          .advisory-grid { grid-template-columns: 1fr !important; }
          .toolbar-row   { flex-direction: column !important; align-items: stretch !important; }
          .ibh-search    { width: 100% !important; box-sizing: border-box !important; }
          .ibh-select    { width: 100% !important; box-sizing: border-box !important; }
          .toolbar-row > div { width: 100% !important; }
          .cta-inner     { flex-direction: column !important; align-items: flex-start !important; }
          .cta-btn       { width: 100% !important; justify-content: center !important; }
        }

        /* ── Mobile portrait (≤480px): iPhone SE 375px ── */
        @media (max-width: 480px) {
          .ibh-hero      { padding: 32px 16px 36px !important; }
          .ibh-content   { padding: 14px 10px 60px !important; }
          .founders-grid { grid-template-columns: 1fr !important; }
          .experts-grid  { grid-template-columns: repeat(2, 1fr) !important; }
        }

        @media (max-width: 380px) {
          .experts-grid  { grid-template-columns: 1fr !important; }
        }

        /* ── Surface Duo (540px) — founders cards go vertical ── */
        @media (min-width: 481px) and (max-width: 560px) {
          .founders-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 10px !important;
          }
          .founder-card-wrap > div {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
            padding: 16px 10px 14px !important;
            gap: 10px !important;
          }
          .founder-card-wrap > div > div:first-child {
            transform: scale(0.70);
            margin-top: -10px;
            margin-bottom: -10px;
            flex-shrink: 0 !important;
          }
          .founder-card-wrap > div > div:last-child {
            min-width: unset !important;
            flex: unset !important;
          }
        }
      `}</style>

      <div style={{ fontFamily: "'Inter', sans-serif", background: "#f0f2f8", minHeight: "100vh" }}>

        {/* ══════════════════════ HERO ══════════════════════ */}
        <div
          className="ibh-hero"
          style={{
            background: "#09071e",
            padding: "44px 52px 44px",
            position: "relative",
            overflow: "hidden",
            minHeight: "clamp(200px, 29vw, 380px)",
          }}
        >
          <div style={{
            position: "absolute", inset: 0, pointerEvents: "none",
            background: "linear-gradient(to right, #130f45 0%, #0f0c38 40%, transparent 70%)",
          }} />
          <div style={{
            position: "absolute", inset: 0, pointerEvents: "none",
            background: "radial-gradient(ellipse 65% 100% at 75% 50%, #3a1caa 0%, #2510a0 25%, #1a0d6e 50%, transparent 72%)",
          }} />

          <HeroLandscapeImage />

          <div style={{
            position: "absolute", top: "6%", left: "32%", width: 48, height: 48,
            pointerEvents: "none",
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='7' cy='7' r='1.3' fill='rgba(160,140,255,1)'/%3E%3C/svg%3E")`,
            backgroundSize: "10px 10px",
            WebkitMaskImage: "radial-gradient(circle, rgba(0,0,0,0.70) 40%, rgba(0,0,0,0.30) 65%, transparent 100%)",
            maskImage: "radial-gradient(circle, rgba(0,0,0,0.70) 40%, rgba(0,0,0,0.30) 65%, transparent 100%)",
            opacity: 0.75, zIndex: 2,
          }} />

          <svg style={{
            position: "absolute", right: -60, top: "50%", transform: "translateY(-50%)",
            width: 480, height: 480, pointerEvents: "none", overflow: "visible", zIndex: 1,
          }} viewBox="0 0 480 480">
            {[70, 130, 195, 265, 340].map((r, i) => (
              <circle key={i} cx="480" cy="240" r={r} fill="none"
                stroke="rgba(180,150,255,0.10)" strokeWidth={i === 0 ? 0.9 : 0.6} />
            ))}
          </svg>

          {particles.map((p, i) => (
            <div key={i} className="ibh-particle" style={{
              top: p.top, left: p.left, width: p.size, height: p.size,
              "--op": p.opacity * 0.6, "--dur": p.dur, "--delay": p.delay, zIndex: 2,
            }} />
          ))}

          <div className="ibh-hero-text" style={{ position: "relative", zIndex: 3, maxWidth: "min(480px, 46%)" }}>
      <button
  className="back-btn"
  onClick={() => window.history.back()}
  style={{
    display: "inline-flex", alignItems: "center", gap: 6,
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.15)",
    color: "rgba(255,255,255,0.65)",
    fontSize: 10.5, fontWeight: 700,
    letterSpacing: "0.14em", textTransform: "uppercase",
    padding: "5px 14px", borderRadius: 20,
    marginBottom: 24, fontFamily: "'Inter', sans-serif", cursor: "pointer",
  }}
>
  &lt; Back
</button>

            <h1 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "clamp(28px, 3.4vw, 52px)",
              fontWeight: 700, color: "#fff", lineHeight: 1.10, marginBottom: 16,
              textShadow: "0 4px 32px rgba(80,20,255,0.35)",
            }}>
              Meet the Minds<br />
              Behind{" "}
              <span style={{ background: "linear-gradient(90deg,#f97316 0%,#e879f9 55%,#818cf8 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                IBH
              </span>
            </h1>

            <p style={{
              color: "rgba(255,255,255,0.52)",
              fontSize: 16, maxWidth: 400, lineHeight: 1.8,
              fontFamily: "'Inter', sans-serif",
            }}>
              A team of experienced professionals committed to helping businesses start, grow and scale with confidence.
            </p>
          </div>
        </div>

        {/* ── Main content ── */}
        <div className="ibh-content" style={{ padding: "24px 28px 60px" }}>

          {/* FOUNDERS */}
          <SectionCard
            icon={<IconUsers size={20} color={fc.accent} />}
            title="Founders"
            subtitle="Leading the vision. Driving the mission."
            accent={fc.accent}
            border="1.5px solid #f37c23"
          >
            <div className="founders-grid">
              {founders.map(f => (
                <div key={f.id} className="founder-card-wrap">
                  <PersonCard person={f} accentColor={fc.accent} />
                </div>
              ))}
            </div>
          </SectionCard>

          {/* OUR EXPERTS */}
          <SectionCard
            icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={ec.accent} strokeWidth="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6M9 12h6M9 15h4"/></svg>}
            title="Our Experts"
            subtitle="Domain specialists delivering impactful solutions."
            accent={ec.accent}
            border="1.5px solid #002a9b"
          >
            <div className="toolbar-row" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10, marginBottom: 16 }}>
              <div style={{ position: "relative" }}>
                <div style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}>
                  <IconSearch size={14} color="#aaa" />
                </div>
                <input className="ibh-search" type="text" placeholder="Search experts..."
                  value={search} onChange={e => setSearch(e.target.value)}
                  style={{ border: `1px solid ${ec.border}`, borderRadius: 8, padding: "8px 12px 8px 32px",
                    fontSize: 13, color: "#333", fontFamily: "'Inter', sans-serif",
                    width: 220, background: "#fafbff", transition: "border-color 0.2s, box-shadow 0.2s" }} />
              </div>
              <div style={{ position: "relative" }}>
                <select className="ibh-select" value={domain} onChange={e => setDomain(e.target.value)}
                  style={{ border: `1px solid ${ec.border}`, borderRadius: 8, padding: "8px 32px 8px 12px",
                    fontSize: 13, color: "#333", fontFamily: "'Inter', sans-serif",
                    background: "#fafbff", appearance: "none", WebkitAppearance: "none",
                    cursor: "pointer", width: 200 }}>
                  {DOMAINS.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
                <div style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  <IconChevronDown size={12} color="#777" />
                </div>
              </div>
            </div>
            {filteredExperts.length > 0 ? (
              <div className="experts-grid">
                {filteredExperts.map(e => <ExpertCard key={e.id} person={e} />)}
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa" }}>
                <div style={{ marginBottom: 10 }}><IconSearch size={36} color="#ccc" /></div>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14 }}>
                  No experts found for "{search || domain}"
                </p>
              </div>
            )}
          </SectionCard>

          {/* ADVISORY BOARD */}
          <SectionCard
            icon={<IconUsers size={20} color={ac.accent} />}
            title="Advisors & Mentors"
            subtitle="Guiding us with wisdom. Inspiring us to grow."
            accent={ac.accent}
            border="1.5px solid #00a000"
          >
            <div className="advisory-grid">
              {seniorAdvisory.map(a => <PersonCard key={a.id} person={a} accentColor={ac.accent} />)}
            </div>
          </SectionCard>

          {/* CTA */}
          <div className="cta-inner" style={{
            background: "linear-gradient(135deg,#0f0c2e 0%,#1a1060 100%)",
            borderRadius: 16, padding: "28px 32px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            flexWrap: "wrap", gap: 16,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{ width: 46, height: 46, borderRadius: 12, background: "rgba(139,92,246,0.22)",
                display: "flex", alignItems: "center", justifyContent: "center" }}>
                <IconUsers size={22} color="#a78bfa" />
              </div>
              <div>
                <h3 style={{ fontSize: 18, fontWeight: 800, color: "#fff", fontFamily: "'Poppins', sans-serif", marginBottom: 4 }}>
                  Let's Build Your Business, Together
                </h3>
                <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", fontFamily: "'Inter', sans-serif" }}>
                  Connect with our experts and take your business to the next level.
                </p>
              </div>
            </div>
            <a href="tel:+918274964884" className="cta-btn">
              <IconPhone size={16} color="#fff" />
              Talk With an Expert
              <IconArrowRight size={13} color="#fff" />
            </a>
          </div>

        </div>
      </div>
    </>
  );
}